<template>
  <div  class="columns is-centered" v-if="isLoaded && chartOptions.option">
    <div class="column is-12-tablet is-9-desktop">
      <vue-highcharts
        type="chart"
        :options="chartOptions.option"
        :redrawOnUpdate="true"
        :oneToOneUpdate="true"
        :animateOnUpdate="true"
        @rendered="onRender"
        @update="onUpdate"
        @destroy="onDestroy"/>
    </div>
  </div>
</template>

<script>
/*
check data Model
  Full: display two charts in two side by side columns: each column has a chart on top and description (common ones, and species specific) on bottom
  Forested/Prairie: display one chart on left, and description on right
*/
import { reactive, ref, watch } from 'vue';
import { getSpeciesHabitatFewDetectionGraph } from '@/services/data/graph-data.js'
import Vue3Highcharts from '@/components/vue3-highcharts/index';
import { credits, defaultXAxis, defaultYAxis, axisFontStyle, titleFontStyle } from '@/config/profile-config';
import { mergeDeep } from '@/lib/common';
// import { useHFCustomIcon } from '@/components/vue3-highcharts/highchart-util'
// import Highcharts from 'highcharts';
// // Load the exporting module.
// import Exporting from 'highcharts/modules/exporting';
import { useApp } from '@/composables/state/profileState';

// Initialize exporting module.
// Exporting(Highcharts);
export default {
  name: 'few-detection--section',
  components: {
    'vue-highcharts': Vue3Highcharts
  },
  props: ['isNorth'],
  setup (props) {
    const isLoaded = ref(1);
    const { state } = useApp();
    const series = reactive([]);
    let chartLabel = reactive({});
    const chartOptions = reactive({});
    const categories = reactive([]);
    const colors = reactive([]);
    const loadData = async () => {
      // get linear data
      if (!state.tsn) {
        return;
      }
      /* in 2022, mixed older chart category/order and new one, new ones for lichen moss, frogs */
      // const isNewOrder = [4, 5, 9].includes(state.sppGroup.groupId);
      /* in 2023, bird uses old catgory, the rest use new category */
      const isNewOrder = !state.isBird;
      const data = await getSpeciesHabitatFewDetectionGraph(state.tsn, state.year, props.isNorth, state.isSpecies, isNewOrder); /* state.tsn */

      data.values?.forEach(row => {
        /* add category with two levels */
        const matchIndex = categories.findIndex(x => x.name === row.subCategory);
        if (matchIndex >= 0) {
          categories[matchIndex].categories.push(row.label);
        } else {
          categories.push({ name: row.subCategory, categories: [row.label] });
        }
      });

      chartLabel = data.title;
      /* for each treed or non-treed value, label entry
          save color, label, subCategory
          save columnValue (for columns), lower/upper (for error bars)
        */
      const columnValue = [];

      data.values && data.values.forEach(row => {
        columnValue.push(row.mean);
        colors.push(row.color);
      });

      series.push({
        type: 'column',
        data: columnValue,
        showInLegend: false
      });

      isLoaded.value++;

      chartOptions.option = packageChartOptions();
    };

    const packageChartOptions = (label = '') => {
      return {
        credits,
        chart: {
          type: 'column',
          events: {
            render: function () { // hide default legend
              // $('#' + divId + ' .highcharts-legend-item rect').attr('width', '0');
            }
          },
          height: 500
        },
        title: {
          text: chartLabel.title,
          style: titleFontStyle
        },
        xAxis: mergeDeep(defaultXAxis, {
          categories: categories,
          tickWidth: 0, // to remove grouped label grid lines
          lineColor: '#666',
          labels: {
            groupedOptions: [{
              rotation: 0,
              style: axisFontStyle // set red font for labels in 1st-Level same as Y axis
            }, { // suppose to set second layer font, but not work
              style: axisFontStyle
              // rotation: -45,
            }],
            rotation: -45 // 0-level options aren't changed, use them as always
          },
          breaks: [{
            from: (categories[0].categories.length) - 0.1,
            to: (categories[0].categories.length),
            breakSize: 1
          }]
        }),
        yAxis: mergeDeep(defaultYAxis, {
          min: -1,
          max: 1,
          tickInterval: 0.5,
          title: {
            text: chartLabel.yLabel
          }
        }),
        plotOptions: {
          column: {
            colorByPoint: true,
            colors: colors,
            groupPadding: 0, // the smaller the wide the bars will be
            grouping: true,
            dataLabels: {
              enabled: false,
              crop: false
              // overflow: 'none',
              // useHTML: true,
              // formatter: function () {
              //   return (this.point.y > 0 ? '+' : '') + this.point.y.toFixed(2) + '%';// + useHFCustomIcon(extenedHfCategory, 15, this.point.name)
              // }
            }
          }
        },
        tooltip: {
          backgroundColor: '#FCFFC5',
          headerFormat: '',
          pointFormatter: function () { return this.category + ': ' + this.y.toFixed(2) + '%'; }
          // pointFormat: `${point.name}: {point.y}%`
        },
        series: series
      }
    };

    watch(() => state.tsn, async (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        loadData();
      }
    });
    return {
      loadData,
      chartOptions,
      isLoaded
    }
  },
  created () {
    this.loadData();
  }
}
</script>

<style>

</style>
